import client_config from '@/assets/json/client_config.json'
import axios from '@/services/'
import { Mask } from 'maska'
import { defineStore } from 'pinia'
import { useAuthStore } from './auth'
import axiosInstance from '@/services/'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      languageId: 2,
      topbarState: null,
      startbarState: null,
      endbarState: null,
      servicesList: [],
      rawModules: [],
      clientConfig: null,
      startedService: null,
      visitorCount: null,
      showcase: {
        skipValidation: false
      },
      additionalServices: null,
      envConfig: null,

      /**
       * confirm state
       */
      confirmConfig: {
        title: null,
        message: null,
        posLabel: 'OK',
        negLabel: 'cancel'
      },
      confirmShown: false,
      confirmResponse: null
    }
  },

  getters: {
    hasDrawer() {
      return this.topbarState || this.endbarState || this.startbarState
    }
  },
  actions: {
    async showConfirmDialog(options) {
      this.confirmConfig = options
      this.confirmShown = true
    },
    async getVisitorCount() {
      if (this.visitorCount) return

      const data = await axios.get('/api/landing/numberOfVisitors')

      const mask = new Mask({ mask: '###,###' })
      this.visitorCount = mask.masked(`${data}`)
    },
    async startService(serviceId) {
      this.startedService = await this.fetchConfig(serviceId)
      if (this.startedService.requestUrl) {
        // eslint-disable-next-line no-unused-vars
        const [_, stepType] = this.startedService.requestUrl.split('/')
        this.startedService.stepType = stepType
      }

      await this.fetchName(serviceId)
    },
    async getServicesList() {
      const languageId = window.$i18n.global.locale.value == 'en' ? 2 : 1
      const data = await axios.get('/api/application/service/transactions/guest', {
        headers: { languageId }
      })
      const services = []
      const modules = data
      this.rawModules = data

      modules.forEach((module) => {
        if (module.localizedName == 'Additional Serivces') {
          this.additionalServices = JSON.parse(module.description).Services
          return
        }

        module.moduleServices.forEach((parentService) => {
          parentService.childs.forEach((subService) => {
            subService.serviceTransactions.forEach((transaction) => {
              const serviceNameAsList = [
                module.localizedName,
                parentService.localizedName,
                subService.localizedName,
                transaction.localizedName
              ]

              services.push({
                localizedServiceName: serviceNameAsList.join(' - '),
                moduleId: module.id,
                transactionId: transaction.id,
                favactive: ''
              })
            })
          })
        })
      })

      console.info('services fetched')

      this.servicesList = services
    },

    async fetchClientConfig() {
      this.clientConfig = client_config
    },

    async fetchEnvConfig() {
      this.envConfig = await axiosInstance.get('/api/content/environment')
    },

    async fetchConfig(serviceId, { administrativeRegionId = 1 } = {}) {
      const data = await axios.get('/api/service/transactions/config', {
        headers: {
          languageId: this.languageId
        },
        params: {
          applicationId: null,
          serviceTransactionId: serviceId,
          administrativeRegionId
        }
      })

      const parsedConfig = {
        ...data,
        serviceConfig: {
          ...JSON.parse(data.serviceConfig),
          serverPath: data.serverPath,
          icaRatingCode: data.icaRatingCode,
          skipPayment: data.skipPayment,
          transactionId: data.transactionId,
          mainServiceTransactionId: data.mainServiceTransactionId,
          parentJourneyFlag: data.parentJourneyFlag,
          sponsorTypeIds: data.sponsorTypeIds,
          moduleId: data.moduleId
        }
      }
      return parsedConfig
    },

    async fetchName(serviceId) {
      const data = await axios.get(`/api/service/${serviceId}/name`)

      if (Object.keys(this.startedService || {}).length > 0) {
        this.$patch((state) => {
          Object.assign(state.startedService, {
            name: data
          })
        })
      }

      return data
    },

    async fetchShortName(serviceId, applicationId = null) {
      const authStore = useAuthStore()
      const params = {
        serviceTransactionId: +serviceId
      }

      params.applicationId = +applicationId || authStore.user.applicationId || 12

      const data = await axios.get('/api/quick-search/service/short-name', {
        params
      })

      return data
    },

    async fetchServiceCard(serviceId) {
      const serviceCard = {}

      serviceCard.config = await this.fetchConfig(serviceId)
      serviceCard.name = await this.fetchName(serviceId)
      serviceCard.content = await axios.get(`/api/serviceCard/client/${serviceId}`)
      serviceCard.fees = await axios.get(`/api/payment/fees/service/${serviceId}`, {
        params: { includeOptional: true, adminstrativeRegionId: 1 }
      })

      return serviceCard
    }
  },
  persist: true
})
